/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LocationOptionVo } from './LocationOptionVo';
import {
    LocationOptionVoFromJSON,
    LocationOptionVoFromJSONTyped,
    LocationOptionVoToJSON,
    LocationOptionVoToJSONTyped,
} from './LocationOptionVo';

/**
 * 
 * @export
 * @interface AdminStockAdjustLocationOptionsResVo
 */
export interface AdminStockAdjustLocationOptionsResVo {
    /**
     * 可用货位下拉选项（当前仓库手工货架）
     * @type {Array<LocationOptionVo>}
     * @memberof AdminStockAdjustLocationOptionsResVo
     */
    locationOptions?: Array<LocationOptionVo>;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationOptionsResVo interface.
 */
export function instanceOfAdminStockAdjustLocationOptionsResVo(value: object): value is AdminStockAdjustLocationOptionsResVo {
    return true;
}

export function AdminStockAdjustLocationOptionsResVoFromJSON(json: any): AdminStockAdjustLocationOptionsResVo {
    return AdminStockAdjustLocationOptionsResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationOptionsResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationOptionsResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'locationOptions': json['locationOptions'] == null ? undefined : ((json['locationOptions'] as Array<any>).map(LocationOptionVoFromJSON)),
    };
}

export function AdminStockAdjustLocationOptionsResVoToJSON(json: any): AdminStockAdjustLocationOptionsResVo {
    return AdminStockAdjustLocationOptionsResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationOptionsResVoToJSONTyped(value?: AdminStockAdjustLocationOptionsResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationOptions': value['locationOptions'] == null ? undefined : ((value['locationOptions'] as Array<any>).map(LocationOptionVoToJSON)),
    };
}

